import { request, Rows } from './request';
import { ConsultingCategory } from './models/consulting-categories/res/ConsultingCategory';

export const fetchConsultingCategories = async (partnerId: number | string) => {
  const url = `/mini-web/consulting-categories/${partnerId}`;
  try {
    const { data } = await request<Rows<ConsultingCategory>>({
      method: 'get',
      url,
    });
    const { rows } = data;
    return rows;
  } catch (e) {
    return [];
  }
};
